import script from "./Access.vue?vue&type=script&lang=ts&setup=true"
export * from "./Access.vue?vue&type=script&lang=ts&setup=true"

import "./Access.vue?vue&type=style&index=0&id=29484d2a&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29484d2a"]])

export default __exports__